import { Box, CardMedia, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import companyEmployeeService from "../../services/companyEmployeeService";
import { cardStyle, greyBorderStyle } from "../../shared/Theme";

const CardCyberAwareness = () => {

	const navigate = useNavigate();
	
	let [ percentComplete, setPercentComplete ] = useState(0);
	
	useEffect(() => {
		const totals = getTotals();
		setPercentComplete(getPercentComplete(totals));
	}, []);
	
	const getTotals = () => {
		const totals = {
			notStarted: 0,
			started: 0,
			completed: 0
		};
		for (let i = 0; i < companyEmployeeService.courseStats.length; i++) {
			const stats = companyEmployeeService.courseStats[i];
			totals.notStarted += stats.employeesNotStarted;
			totals.started += stats.employeesStarted;
			totals.completed += stats.employeesCompleted;
		}
		
		return {
			completed: totals.completed,
			total: totals.notStarted + totals.started + totals.completed
		}
	};
	
	const getPercentComplete = (totals) => {
		if (totals.total === 0) return 0;
		return Math.floor((totals.completed / totals.total) * 100);
	};
	
	const getRedGreenPercentTarget = (i, j) => {
		return ((i * personColumns.length) + j) * (100 / (personColumns.length * personRows.length));
	};
	
	const handleTitleClick = () => {
		navigate("/training");
	};
	
	const personRows = [0, 0, 0];
	const personColumns = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
	
	return (
		<Box sx={{ borderRight: "2px solid", ...greyBorderStyle }}>
			<Stack
				direction="column"
				onClick={handleTitleClick}
				sx={{ ...cardStyle, width: "28em", height: "16em", '&:hover': { cursor: "pointer" } }}
			>
				<Typography
					variant="h5"
					sx={{
						width: "100%",
						textAlign: "center",
						marginTop: "1em",
						cursor: "pointer",
						fontWeight: "bold"
					}}
					onClick={handleTitleClick}
				>
					Cyber Awareness
				</Typography>
				<Stack direction="column" spacing="0.25em" justifyContent="center" sx={{ marginTop: "1.5em" }}>
					{personRows.map((rowItem, i) => {
						return (<Stack direction="row"  spacing="0.2em" justifyContent="center" key={`pr_${i}`}>
							{personColumns.map((columnItem, j) => {
								return (<CardMedia
									key={`prc_${i}_${j}`}
									component='img'
									src={percentComplete >= getRedGreenPercentTarget(i, j)?
										"/green-person.png" : "/red-person.png"}
									alt="cyber awareness person icon" 
									sx={{ width: "0.8em" }}
								/>)
							})}
						</Stack>)
					})}
				</Stack>
			</Stack>
		</Box>
	);

}

export default CardCyberAwareness;